import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-payments-dashboard',
  templateUrl: './payments-dashboard.component.html',
  styleUrls: ['./payments-dashboard.component.scss']
})
export class PaymentsDashboardComponent implements OnInit, OnDestroy {

  gateways;
  transactions;
  getGatewaysSubscription: Subscription;
  getPaymentsSubscription: Subscription;

  constructor(private paymentsService: PaymentsService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getGateways();
    this.getPayments(moment().startOf('day').valueOf(), moment().valueOf());
  }

  private getGateways() {
    this.getGatewaysSubscription = this.paymentsService.getGatewaysCounts().subscribe(
      (res) => {
        this.gateways = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getPayments(from, to) {
    this.getPaymentsSubscription = this.paymentsService.getTransactions(from, to).subscribe(
      (res) => {
        this.transactions = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-file-invoice-dollar', 'gateways-page.payments'));
  }

  ngOnDestroy() {
    if (this.getGatewaysSubscription) { this.getGatewaysSubscription.unsubscribe(); }
    if (this.getPaymentsSubscription) { this.getPaymentsSubscription.unsubscribe(); }
  }
}
